import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasListItemIcon = ({ children, className, sx, ...props }) => (
  <span className={cn('flex items-center justify-center mr-3 min-w-[24px] text-text-secondary', className)} {...props}>
    {children}
  </span>
)

AdasListItemIcon.propTypes = { children: PropTypes.node, className: PropTypes.string }
